import {useMemo} from 'react';

export const useManageClusterTip = (selectedNum = 0, restSelectedNum = 0) => {
    return useMemo(
        () => {
            return `当前服务网格实例已纳管${selectedNum}个集群，还可加入${restSelectedNum}个集群。`
                + '请确保被同一网格实例纳管的多个CCE集群的容器网段互相可达，且CIDR互不重叠。同一个CCE命名空间，仅能同时被一个服务网格实例管理。';
        },
        [restSelectedNum, selectedNum]
    );
};
